export const version = '6.4-beta.1725';
